import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { NavigationService } from 'src/app/services/navigation.service';
import { CustomerRequestDataService } from 'src/app/services/customer-request-data.service';
import { RegisterDataService } from 'src/app/services/register-data.service';
import { NotificationService } from 'src/app/services/notification-service';
import { ResellerService } from 'src/app/services/reseller.service';
import { CrudStatusType } from 'src/app/enum/crud-status-type';


@Component({
  selector: 'app-manage-reseller-sales-add',
  templateUrl: './manage-reseller-sales-add.component.html',
  styleUrls: ['./manage-reseller-sales-add.component.scss']
})
export class ManageResellerSalesAddComponent implements OnInit {

  form: FormGroup;
  paramsId: any;
  mode: number;
  isViewMode = false;
  userDetails: any = {};
  resellerList: any = [];
  filterRoleList: any = [];

  constructor(private navigate: NavigationService,
    private fb: FormBuilder,
    public dialog: MatDialog,
    public CustomerRequestDataService: CustomerRequestDataService,
    private ResellerService: ResellerService,
    private activateRoute: ActivatedRoute,
    private toastr: NotificationService
  ) {
    this.activateRoute.params.subscribe((params: any) => {
      this.paramsId = parseInt(params.id);
      this.mode = parseInt(params.mode);
      this.isViewMode = this.mode === 2;
    });
  }

  ngOnInit(): void {
    this.ResellerService.getResellerList(null).subscribe(res => {
      debugger
      this.resellerList = res;
      this.filterRoleList = res;
    });
    this.initializeValidators();
    if (this.mode == 1 || this.mode == 2) {
      this.getFormDetails();
    }
  }

  initializeValidators() {
    this.form = this.fb.group({
      resellerSalesName: ['', [Validators.required, Validators.pattern(/\S/)]],
      resellerSalesCode: ['', [Validators.required, Validators.pattern(/\S/)]],
      resellerId: ['', [Validators.required, Validators.pattern(/\S/)]],
      resellerCode: [''],
      resellerName: [''],
      presentInPrepaid:['']
    });
  }

  getFormDetails() {
    this.ResellerService.getResellerSalesById(this.paramsId).subscribe((res) => {
      this.userDetails = res;
      this.form.patchValue({
        ...res,
        IsAddOrUpdateInReach: res.presentInPrepaid === true
      });
      if (this.isViewMode) {
        this.form.disable();
      }
    });
  }

  goToManageResellerSales() {
    this.navigate.goToManageResellerSales();
  }

  onsubmit() {
    if (this.isViewMode) {
      return; // view mode never submits
    }

    if (this.form.valid) {
      const { addOrUpdateInPrepaid, AddOrUpdateInPrepaid, ...existingDetails } = this.userDetails;
      let payload = {
        ...existingDetails,
        ...this.form.value,
        // AddOrUpdateInPrepaid: this.mode === 0 ? 1 : 2
      }

      if (this.form.value.presentInPrepaid) {
        payload.AddOrUpdateInPrepaid = this.mode === 0 ? 1 : 2;
      } else {
        payload.AddOrUpdateInPrepaid = 0; 
      }

      this.ResellerService.addOrUpdateResellerSales(payload).subscribe((res) => {
        if (res != null) {

          if (this.mode == 0 && res.isSuccess) {
            this.toastr.showSuccess("Added Successfully!");
          }
          else  {
            this.toastr.showSuccess(res.message);
          }
        }
        else {
          this.toastr.showError("Failed to save!");
        }
        this.goToManageResellerSales();
      });
    } else {
      this.form.markAllAsTouched();
      this.toastr.showError("Please fill in all mandatory fields!")
    }
  }

  onResellerChange(event) {
    const selected = this.resellerList.find(r => r.id === event.value);
    if (selected) {
      this.form.patchValue({
        resellerId: selected.id,
        resellerCode: selected.resellerCode,
        resellerName: selected.resellerName
      });
    }
  }


}
